// extracted by mini-css-extract-plugin
export var drawerPaper = "_1n-0";
export var itemImage = "_1n-1";